module.exports = __webpack_public_path__ + "img/zhongbiao.63d7dc8d.png";